import { updateField, fieldByName } from "@/lib/printess/utils";
import Row from "@/lib/printess/row";

export default class Table {
  #field;
  #rows;
  #cachedTemplateRow;

  constructor(api, field) {
    this.name = field.data.na;

    this.id = field.id;
    this.api = api;
    this.#field = field;
    this.#rows = JSON.parse(this.#field.data.v).map((row) => new Row(row));
  }

  static async find(api, name) {
    //  This will me removed in the future from the Printess API. use SelectionChanged callback instead (or properties from api)
    const raw = await fieldByName(api, name);
    if (!raw) return;

    return new Table(api, raw);
  }

  get unlockedProducts() {
    return this.#products.filter((product) => product.isUnlocked);
  }

  // A "matching product row" is that which is both unlocked and fuzzy matches on name.
  matchingProductRow(name, { unlocked = false } = {}) {
    if (unlocked) {
      return this.unlockedProducts.find((product) => product.matches(name));
    } else {
      // otherwise just look for all.
      return this.#products.find((product) => product.matches(name));
    }
  }

  matchingCategoryRow(name) {
    return this.#categories.find((category) => category.matches(name));
  }

  addOrUpdateFromMenuItem(menuItem) {
    const match = this.matchingProductRow(menuItem.name);
    if (match) {
      match.updateFromMenuItem(menuItem, { lock: false });
    } else {
      this.addFromMenuItem(menuItem, { lock: false });
    }
  }

  addCategory(categoryName) {
    console.debug(`Adding ${categoryName} to ${this.name}`);
    const row = this.#templateRow;

    row.setCategory();
    row.name = categoryName;

    this.#add(row);
  }

  addFromMenuItem(menuItem, { lock = true } = {}) {
    console.debug(`Adding ${menuItem.name} to ${this.name}`);
    const row = this.#templateRow;
    if (!row) {
      console.error(`No template row found for ${this.name}`);
      return;
    }
    row.updateFromMenuItem(menuItem, { lock });

    this.#add(row);
  }

  updateFromMenuItem(menuItem, { unlocked = false, lock = true } = {}) {
    const match = this.matchingProductRow(menuItem.name);
    match.updateFromMenuItem(menuItem, { unlocked, lock });
  }

  removeFromMenuItem(menuItem) {
    console.debug(`Removing ${menuItem.name} from ${this.name}`);

    const match = this.matchingProductRow(menuItem.name);

    if (match) {
      this.#rows = this.#rows.filter((row) => row !== match);
    } else {
      console.debug(
        `No matching row found for ${menuItem.name} in ${this.name}`,
      );
    }
  }

  get #templateRow() {
    let row = this.#cachedTemplateRow;

    if (!row) {
      this.#cachedTemplateRow = row = this.#products[0];
    }

    return row?.copyAsTemplate();
  }

  get #products() {
    return this.#rows.filter((row) => row.isProduct);
  }

  get #categories() {
    return this.#rows.filter((row) => row.isCategory);
  }

  #add(row) {
    this.#rows.push(row);
  }

  async write() {
    console.debug(`Writing table to ${this.name}`);

    const updatedJson = JSON.stringify(this.#rows);

    await updateField(this.api, this.name, updatedJson);
  }
}
